{
  "app": { "title": "Administration de la plateforme Journix", "loading": "Chargement" },
  "common": {
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "remove": "Retirer",
    "create": "Créer",
    "edit": "Modifier",
    "close": "Fermer",
    "back": "Retour",
    "next": "Suivant",
    "retry": "Réessayer",
    "search": "Rechercher",
    "filter": "Filtrer",
    "reset": "Réinitialiser",
    "yes": "Oui",
    "no": "Non",
    "loading": "Chargement",
    "language": "Langue",
    "actions": "Actions",
    "menu": "Menu"
  },
  "language_switcher": {
    "label": "Langue",
    "options": { "en": "English", "es": "Español", "fr": "Français", "pt": "Português" }
  },
  "nav": {
    "home": "Accueil",
    "tenants": "Locataires",
    "brands": "Marques",
    "users": "Utilisateurs",
    "reference": "Référence",
    "products": "Produits",
    "oidcClients": "Clients OIDC",
    "operators": "Opérateurs",
    "signOut": "Se déconnecter",
    "signIn": "Se connecter"
  },
  "auth": {
    "redirecting": "Redirection vers la connexion…",
    "returning": "Finalisation de la connexion…",
    "signedOutTitle": "Vous êtes déconnecté",
    "signInAgain": "Se reconnecter",
    "sessionExpired": {
      "redirecting": "Redirection vers la connexion… ({{seconds}})",
      "signInNow": "Se connecter maintenant"
    }
  },
  "internalKeys": {
    "title": "Internal API keys",
    "issue": "Issue key",
    "revoke": "Turn off",
    "explanation": "Each key is the X-Internal-Api-Key a product backend presents to saas-auth. A product can have several active keys at once for zero-downtime rotation. The raw key is shown only once at creation — saas-auth stores only a hash.",
    "empty": "No internal keys issued for this product yet.",
    "noLabel": "—",
    "issued": "Internal key issued.",
    "revoked": "Key turned off.",
    "superAdminRequired": "Super admin required to manage internal API keys.",
    "issueTitle": "Issue internal API key",
    "issueBody": "A new high-entropy key is generated by saas-auth and shown once. Give it an optional label to identify which backend it belongs to.",
    "revokeTitle": "Turn off this key?",
    "revokeBody": "Turn off the key {{prefix}}…? A backend still using it will be rejected immediately. This cannot be undone — issue a new key to rotate.",
    "columns": {
      "keyPrefix": "Key prefix",
      "label": "Label",
      "status": "Status",
      "created": "Created",
      "revoked": "Revoked"
    },
    "statuses": {
      "ACTIVE": "Active",
      "REVOKED": "Revoked"
    },
    "fields": {
      "label": "Label (optional)",
      "labelPlaceholder": "e.g. dink-api prod",
      "labelHelper": "A human note shown in the list. Optional."
    },
    "reveal": {
      "title": "Copy this internal key now",
      "prefix": "Prefix: {{prefix}}",
      "secureTransmit": "Deliver this key to the product backend owner over a secure channel (e.g. a password manager share) — it becomes that backend's X-Internal-Api-Key. saas-auth keeps only a hash; this value cannot be retrieved again."
    }
  },
  "limitDefinitions": {
    "title": "Resource-limit definitions",
    "explanation": "Each definition is a per-product limit lever (e.g. number of locations). Plans set a value per lever; a tenant without a plan falls back to the default here. The key is fixed once created.",
    "superAdminRequired": "Super admin required to manage resource-limit definitions.",
    "empty": "No limit definitions for this product yet.",
    "noDefault": "—",
    "add": "Add definition",
    "edit": "Edit limit definition",
    "created": "Limit definition created.",
    "updated": "Limit definition updated.",
    "deleted": "Limit definition deleted.",
    "deleteTitle": "Delete limit definition?",
    "deleteBody": "Delete {{key}}? Any plan values set for this lever are affected per the backend. This cannot be undone.",
    "columns": {
      "key": "Key",
      "label": "Label",
      "valueType": "Value type",
      "defaultValue": "Default"
    },
    "valueTypes": {
      "INT": "Integer",
      "BOOL": "Boolean",
      "STRING": "String"
    },
    "fields": {
      "key": "Key",
      "keyHelper": "The stable lever identifier the product backend reads. Can't be changed after create.",
      "label": "Label",
      "valueType": "Value type",
      "valueTypeHelper": "INT (integer), BOOL (true/false), or STRING (free text).",
      "valueTypeImmutable": "Can't be changed after create.",
      "defaultValue": "Default value",
      "defaultHelper": {
        "INT": "The fallback integer when no plan sets this lever. Leave blank for no default.",
        "BOOL": "The fallback (true or false) when no plan sets this lever. Leave blank for no default.",
        "STRING": "The fallback text when no plan sets this lever. Leave blank for no default."
      }
    },
    "validation": {
      "badInt": "Must be a whole number (e.g. 5).",
      "badBool": "Must be true or false."
    }
  },
  "plans": {
    "title": "Resource-limit plans",
    "explanation": "Each plan is a named tier with a value per limit lever. Assign a plan to a tenant to grant its values; a lever a plan leaves unset falls back to the definition default. Edit a plan’s values with the tune control.",
    "superAdminRequired": "Super admin required to manage resource-limit plans.",
    "empty": "No plans for this product yet.",
    "noDescription": "—",
    "add": "Add plan",
    "edit": "Edit plan",
    "editLimits": "Edit limit values",
    "created": "Plan created.",
    "updated": "Plan updated.",
    "deleted": "Plan deleted.",
    "limitsSaved": "Plan limits saved.",
    "deleteTitle": "Delete plan?",
    "deleteBody": "Delete {{name}}? A tenant assigned this plan must be reassigned first per the backend. This cannot be undone.",
    "limitsTitle": "Edit limit values — {{name}}",
    "limitsExplanation": "Set this plan’s value for each lever. Leave a number or text lever blank to use the definition default.",
    "noDefinitions": "This product has no limit definitions yet. Add definitions above before setting plan values.",
    "limitDefault": "{{value}} (default)",
    "limitNone": "—",
    "columns": {
      "name": "Name",
      "description": "Description",
      "active": "Active",
      "limits": "Limits"
    },
    "statuses": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "fields": {
      "name": "Name",
      "description": "Description",
      "descriptionHelper": "Optional. Leave blank for none.",
      "active": "Active"
    },
    "validation": {
      "badInt": "Must be a whole number (e.g. 5)."
    }
  },
  "ghl": {
    "title": "GoHighLevel integration",
    "explanation": "This config lets the tenant's product backend operate against the tenant's GoHighLevel account. The private integration token is write-only — it is never displayed again after you save it.",
    "superAdminRequired": "Super admin required to manage the GHL integration.",
    "empty": "No GHL integration configured for this tenant yet.",
    "saved": "GHL integration saved.",
    "deleted": "GHL integration removed.",
    "create": "Create integration",
    "delete": "Delete integration",
    "deleteTitle": "Delete GHL integration?",
    "deleteBody": "This removes the tenant's GHL integration. The tenant's product backend will no longer be able to operate against its GoHighLevel account until a new integration is configured. This cannot be undone.",
    "locationLabel": "Location ID",
    "tokenSet": "Token set ({{suffix}})",
    "tokenUnset": "No token stored",
    "created": "Created",
    "updated": "Updated",
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "fields": {
      "locationId": "Location ID",
      "locationIdPlaceholder": "e.g. loc_abc123",
      "token": "Private integration token",
      "tokenPlaceholder": "Paste the GHL private integration token",
      "tokenReplacePlaceholder": "Enter a new token to replace",
      "tokenHelper": "Write-only — shown only as a masked suffix after saving.",
      "tokenReplaceHelper": "Leave blank to keep the current token. Type a value only to replace it.",
      "active": "Active"
    },
    "errors": {
      "tokenRequired": "A private integration token is required."
    }
  },
  "tenantPlan": {
    "title": "Resource-limit plan",
    "explanation": "Assign a resource-limit plan to grant this tenant the plan's values; a lever the plan leaves unset falls back to the definition default. The product backend's server-to-server read is authoritative — the effective limits below are a display convenience.",
    "superAdminRequired": "Super admin required to manage the resource-limit plan.",
    "noProduct": "Assign a product to this tenant before managing its resource-limit plan.",
    "noPlans": "No plans are defined for this product yet. Create a plan on the product screen first.",
    "currentPlan": "Current plan",
    "noPlan": "No plan assigned",
    "selectLabel": "Plan",
    "inactiveOption": "{{name}} (inactive)",
    "assign": "Assign plan",
    "unassign": "Unassign plan",
    "assigned": "Plan assigned.",
    "unassigned": "Plan removed.",
    "unassignTitle": "Unassign plan?",
    "unassignBody": "This removes the tenant's plan assignment. Its effective limits fall back to the definition defaults until a plan is assigned again.",
    "effectiveTitle": "Effective limits",
    "effectiveEmpty": "No effective limits — this product has no definitions with a plan value or a default.",
    "boolEnabled": "Enabled",
    "boolDisabled": "Disabled",
    "columns": {
      "lever": "Lever",
      "value": "Effective value",
      "source": "Source"
    },
    "source": {
      "override": "Override",
      "plan": "Plan",
      "default": "Default"
    }
  },
  "integrationSettings": {
    "title": "Integration Settings (pass-through)",
    "explanation": "Generic per-tenant integration configuration the tenant's product backend reads. saas-admin stores these opaque values and does not interpret them. Values marked secret are write-only — shown only as a masked suffix after saving. This is separate from the GoHighLevel integration above.",
    "superAdminRequired": "Super admin required to manage integration settings.",
    "empty": "No integration settings configured for this tenant yet.",
    "noKeys": "No keys in this group yet.",
    "searchPlaceholder": "Search keys by name or value",
    "searchAriaLabel": "Search integration keys",
    "noMatches": "No keys match your search.",
    "table": {
      "ariaLabel": "Integration keys",
      "key": "Key",
      "value": "Value",
      "actions": "Actions"
    },
    "active": "Active",
    "addGroup": "Add group",
    "deleteGroup": "Delete group",
    "deleteGroupTitle": "Delete group?",
    "deleteGroupBody": "This removes the group and all of its keys (including any stored secrets). The tenant’s product backend will no longer read these settings. This cannot be undone.",
    "addKey": "Add key",
    "replace": "Replace",
    "clear": "Clear",
    "groupAdded": "Group added.",
    "groupDeleted": "Group deleted.",
    "keyAdded": "Key added.",
    "keyUpdated": "Key updated.",
    "keyRemoved": "Key removed.",
    "secret": {
      "set": "Set",
      "notSet": "Not set",
      "masked": "•••• {{suffix}}"
    },
    "fields": {
      "groupName": "Group name",
      "key": "Key",
      "value": "Value",
      "newSecret": "New secret value",
      "isSecret": "Secret",
      "replaceHelper": "Write-only. Leave blank to keep the current secret."
    },
    "errors": {
      "nameRequired": "A name is required.",
      "nameTooLong": "Use at most 100 characters.",
      "nameInvalidChars": "Use only letters, numbers, and the characters . _ -",
      "duplicateKey": "A key with that name already exists.",
      "duplicateGroup": "A group with that name already exists."
    }
  }
}
